import * as $ from 'jquery';
import * as ko from 'knockout';

declare var DobryKantor: any;
declare var BACKENDPATH: any;

export class LoginStatusComponent {
    email: ko.Observable<string>;
    isLoggedIn: ko.Computed<boolean>;

    constructor() {
        this.email = ko.observable(null);
        this.isLoggedIn = ko.computed(() => {
            return this.email() != null;
        })

        $.ajax({
            url: BACKENDPATH + '/api/user/account-email',
            method: 'GET',
            xhrFields: {
                withCredentials: true
            }
        }).then(result => {
            if (result.success) {
                if (result.data != null) {
                    this.email(result.data);
                    $('#header-menu-register').hide();
                    $('#header-menu-login').hide();
                    $('#currency-rates-register').hide();
                    $('#header-options-mobile').hide();
                    $('.col-login').hide();
                    $('.col-logged-in').show();
                    $('#header-menu-mobile-icons-not-logged-in').hide();
                    $('.menu-toggle').addClass('logged-in');
                    $('.show-logged-in').show();
                    $('.hide-logged-in').hide();
                }
            }
        });
    }

    logout() {
        $.ajax({
            url: BACKENDPATH + '/api/user/logout',
            method: 'POST',
            xhrFields: {
                withCredentials: true
            }
        }).then(() => {
            this.email(null);
            $('#header-menu-register').show();
            $('#header-menu-login').show();
            $('#header-options-mobile').show();
            $('#currency-rates-register').show();
            $('.col-login').show();
            $('.col-logged-in').hide();
            $('#header-menu-mobile-icons-not-logged-in').show();
            $('.menu-toggle').removeClass('logged-in');
            $('.show-logged-in').hide();
            $('.hide-logged-in').show();
        })
    }
}

